
const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * User Workshops Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('UserWorkshops', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/user-workshops/:subresource/:useropt/:userid/:option1/:value1/:option2/:value2', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    overview: {params: {subresource: 'overview'}, method: 'GET', isArray: false},
    workshopTotals: {params: {subresource: 'totals', useropt: 'workshop'}, method: 'GET', isArray: false},
    instanceTotals: {params: {subresource: 'totals', useropt: 'instance'}, method: 'GET', isArray: false},
    register: {params: {subresource: 'register', useropt: 'user', userid: '', option1: 'workshop', value1: '', option2: 'instance', value2: ''}, method: 'POST', isArray: false},
    wait: {params: {subresource: 'wait', useropt: 'user', userid: '', option1: 'workshop', value1: '', option2: 'instance', value2: ''}, method: 'POST', isArray: false},
    withdraw: {params: {subresource: 'withdraw', useropt: 'user', userid: '', option1: 'user-workshop', value1: ''}, method: 'POST', isArray: false},
    absent: {params: {subresource: 'absent', useropt: 'user', userid: '', option1: 'user-workshop', value1: ''}, method: 'POST', isArray: false},
    attended: {params: {subresource: 'attended', useropt: 'user', userid: '', option1: 'user-workshop', value1: ''}, method: 'POST', isArray: false},
    searchUsers: {params: {subresource: 'search-users', useropt: ''}, method: 'POST', isArray: true},
    postEmail: {params: {subresource: 'post-email', useropt: ''}, method: 'POST', isArray: false},
    multipleRemovals: {params: {subresource: 'multiple-withdraw'}, method: 'POST', isArray: false},
    queryJoinWait: {params: {subresource: 'query-join-wait'}, method: 'POST', isArray: false}
  });
}]);
